import http from "./httpService";

const apiEndPoint = "/closed-trades";

function closedTradeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

export function getClosedTrades() {
  return http.get(apiEndPoint);
}

export function getClosedTrade(closedTradeId) {
  return http.get(closedTradeUrl(closedTradeId));
}

export function saveClosedTrade(closedTrade) {
  // if (closedTrade._id) {
  //   const body = { ...closedTrade };
  //   delete body._id;
  //   return http.put(closedTradeUrl(closedTrade._id), body);
  // }

  return http.post(apiEndPoint, closedTrade);
}

export function deleteClosedTrade(closedTradeId) {
  return http.delete(closedTradeUrl(closedTradeId));
}
